module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\" style=\"padding-bottom: 5px;\">\r\n    <div class=\"col-md-3 prop-sublabel\">Title</div>\r\n    <div class=\"col-md-4 nopadding\">\r\n        <input type=\"text\" name=\"notificationTitle\" id=\"notificationTitle\" value=\"")
    ; __append(escapeFn(notificationTitle))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\" style=\"padding-bottom: 5px;\">\r\n    <div class=\"col-md-3 prop-sublabel\">Attention Level</div>\r\n    <div class=\"col-md-4 nopadding\">\r\n        <select name=\"attentionLevel\" id=\"attentionLevel\">\r\n            ")
    ;  for (var i = 0; i < attLevelOpts.length; i++) { 
    ; __append("\r\n            <option value=\"")
    ; __append(escapeFn( i ))
    ; __append("\">")
    ; __append(escapeFn(attLevelOpts[i]))
    ; __append("</option>\r\n            ")
    ;  }; 
    ; __append("\r\n        </select>\r\n    </div>\r\n</div>\r\n<div class=\"row\" style=\"padding-bottom: 5px;\">\r\n    <div class=\"col-md-3 prop-sublabel\">Role</div>\r\n    <div class=\"col-md-4 nopadding\">\r\n        <select name=\"notificationRol\" id=\"notificationRol\">\r\n            ")
    ;  var selected = "";
               for (var i = 0; i < roleOpts.length; i++) { 
                   selected = roleOpts[i].id === notificationRolId ? "selected" : "";
            
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn( roleOpts[i].id ))
    ; __append("\" ")
    ; __append(escapeFn( selected ))
    ; __append(" >")
    ; __append(escapeFn(roleOpts[i].name))
    ; __append("</option>\r\n            ")
    ;  }; 
    ; __append("\r\n        </select>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}